import React, { useState } from 'react';

import { Link2Outline } from '@lyearn/icons';
import { Box } from '@lyearn/ui';

import EditLink from './components/EditLink';
import ViewLink from './components/ViewLink';
import { LinkBarProps } from './types';

export const LinkBar: React.FC<LinkBarProps> = (props) => {
  const { href, setHref, onSave, editMode, onDelete } = props;
  const [linkEditMode, setLinkEditMode] = useState(editMode);

  return (
    <Box className="flex h-40 items-center rounded-8 bg-bg-primary ps-12">
      <Link2Outline className="h-20 w-20 text-icon-secondary" />
      {href && linkEditMode ? (
        <ViewLink href={href} onDelete={onDelete} onEditClick={() => setLinkEditMode(false)} />
      ) : (
        <EditLink href={href} setHref={setHref} onSave={onSave} />
      )}
    </Box>
  );
};

export default LinkBar;
